import React, {
  forwardRef,
  useEffect,
  type ReactNode,
  type HTMLAttributes,
} from 'react';

import styledC from 'styled-components';

const Scroller = styledC.div`
  overflow-y: auto;
`;

Scroller.displayName = 'Scroller';

export interface ScrollableProps extends HTMLAttributes<HTMLDivElement> {
  setScrollPosition: () => void;
  storeScrollPosition: () => void;
  children?: ReactNode;
}

export const Scrollable = forwardRef<HTMLDivElement, ScrollableProps>(
  (
    { setScrollPosition, storeScrollPosition, children, ...divProps },
    forwardedRef,
  ) => {
    useEffect(() => {
      // immediately after mount, if there is a stored scroll
      // position, reset this component to be scrolled to that.
      setScrollPosition();
    }, [setScrollPosition]);

    return (
      <Scroller ref={forwardedRef} onScroll={storeScrollPosition} {...divProps}>
        {children}
      </Scroller>
    );
  },
);

Scrollable.displayName = 'Scrollable';
